import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {FlatIconColor, FlatIconColorType, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {noop} from '@Utils/general.util';
import {ClickableDiv} from '@Components/clickable-div';
import styles from './add-account-icon.module.scss';

interface AddAccountIconProps {
  isLoading?: boolean;
  className?: string;
  onClick?: VoidFunction;
}

export function AddAccountIcon({isLoading = false, className = '', onClick = noop}: AddAccountIconProps): ReactElement<AddAccountIconProps> | null {
  const getIcon = (): ReactElement<any> => {
    return (
      <Icon
        isLoading={isLoading}
        icon="icon-plus"
        size={IconSize.SIZE_ICON_16}
        type={IconType.FLAT}
        flatIconType={{color: FlatIconColor.NEUTRAL, type: FlatIconColorType.DEFAULT}}
      />
    );
  };

  return (
    <ClickableDiv onClick={onClick} className={`${styles.addAccount} ${className} spacing-m-l-1 _cursor-pointer`}>
      {getIcon()}
    </ClickableDiv>
  );
}
